export function styleVisibility(shouldBeVisible: boolean): string {
  return shouldBeVisible ? 'visible' : 'hidden';
}
